<template>
  <Boundary :check-is-ok="checkIsAuthenticated">
    <slot />
    <template #fallback="{ onToggle }">
      <slot name="picker" :items="items" :on-pick="onToggle">
        <div class="esia-auth-boundary__picker">
          <EsiaAuthPicker v-bind="$props" :items="items" @pick="onToggle" />
        </div>
      </slot>
    </template>
  </Boundary>
</template>

<script lang="ts" setup>
/* eslint-disable @typescript-eslint/no-explicit-any */
import { ref } from 'vue';

import Boundary from '../../../../boundary';
import itemStorageFactory from '../../helpers/itemStorage.factory';
import { tokenOrganizationsGet } from '../../utils/tokenApplyOrg';
import EsiaAuthPicker, { IProps as IPropsBase } from '../EsiaAuthPicker';

export interface IProps extends Omit<IPropsBase, 'items'> {
  /* Copied */
  baseGet?: () => string;
  keycloak: any;
  notifyError?: (msg: string, cfg?: any) => void;
  /*  */
  checkIsAuthenticated?: () => boolean;
}

const props = defineProps<IProps>();

/* Integrations */
const { set, value: items } = itemStorageFactory({ ref });

/* Methods */
const checkIsAuthenticated = () => {
  return props.checkIsAuthenticated
    ? props.checkIsAuthenticated()
    : Boolean(props.keycloak.idTokenParsed.org_inn);
};

const init = async () => {
  if (checkIsAuthenticated()) return;

  const organizations = tokenOrganizationsGet(props.keycloak);
  if (!organizations) return;

  set(organizations);
};

init();
</script>

<style lang="scss" scoped>
.esia-auth-boundary__picker {
  width: 100%;
  height: 100%;
  overflow: auto;
  padding: 20px;
}
</style>
